import { NAME as APP_NAME } from 'constants';
import * as I18n from 'circe/I18n';

export const NAME = `${APP_NAME}/STOCK_UNIT`;

export const LISTING_ENDPOINT = `${SHIPPING_EDGE}/api/sku/query`;
export const REDUCER_NAME = 'stockUnit';
export const CREATE_FORM_NAME = 'newStockUnit';
export const EDIT_FORM_NAME = 'updateStockUnit';
export const UPLOAD_URL = `${SHIPPING_EDGE}/api/file/upload-batch-file`;
export const DATA_FILE_TYPE = 'SKU';

export const TRUCK_TYPES = {
  VAN: {
    label: I18n.str('VAN', 'Van'),
    value: 'VAN',
  },
  STRAIGHT_TRUCK_ENCLOSED: {
    label: I18n.str('STRAIGHT_TRUCK_ENCLOSED', 'Straight truck enclosed'),
    value: 'STRAIGHT_TRUCK_ENCLOSED',
  },
  TRACTOR_TRAILER_ENCLOSED: {
    label: I18n.str('TRACTOR_TRAILER_ENCLOSED', 'Tractor trailer enclosed'),
    value: 'TRACTOR_TRAILER_ENCLOSED',
  },
  OPEN: {
    label: I18n.str('OPEN', 'Open'),
    value: 'OPEN',
  },
  DRY_BOX: {
    label: I18n.str('DRY_BOX', 'Dry box'),
    value: 'DRY_BOX',
  },
  REEFER: {
    label: I18n.str('REEFER', 'Reefer'),
    value: 'REEFER',
  },
  FLAT_BED: {
    label: I18n.str('FLAT_BED', 'Flat bed'),
    value: 'FLAT_BED',
  },
  SIDE_CURTAIN: {
    label: I18n.str('SIDE_CURTAIN', 'Side curtain'),
    value: 'SIDE_CURTAIN',
  },
  BULKER: {
    label: I18n.str('BULKER', 'Bulker'),
    value: 'BULKER',
  },
};

export const OWNERSHIP_TYPES = [
  { value: 'OWNER', label: I18n.str('owner', 'Owner') },
  { value: 'LEASER', label: I18n.str('leaser', 'Leaser') },
];

export const TAGS = [
  { value: 'food', label: 'food' },
  { value: 'non-food', label: 'non-food' },
  { value: 'hazmat', label: 'hazmat' },
  { value: '', label: 'none' },
];

export const TEMP_CLASSIFICATIONS = [
  { value: 'TC', label: 'TC' },
  { value: 'DRY', label: 'DRY' },
  { value: 'FROZEN', label: 'FROZEN' },
];

export const TYPE_UOM = [
  { value: 'CARTOON', label: 'CARTOON' },
  { value: 'PCS', label: 'PCS' },
  { value: 'CASE', label: 'CASE' },
  { value: 'BOX', label: 'BOX' },
  { value: 'OTHER', label: 'OTHER' },
];

export const STACKABLE = [
  { value: true, label: 'true' },
  { value: false, label: 'false' },
];
